<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Svelte
	import { push, location, params } from 'svelte-spa-router';
	//Stores
	import { extended_dashboards } from 'src/stores/features/dashboards';
	//Components
	import DashWizard from 'src/components/Dashboards/DashWizard/DashWizard.svelte';
	//Helpers
	import { capFirstChar } from '../../../helpers/utilities';
	import { checkIsEventLogTab, sortByPosition } from 'src/components/Lists/list-helpers';
	import type { DashWidgetEditType } from 'src/components/Dashboards/dash-types';

	export let routeParams: {
		type: string;
		id: string;
	};
	export let showModal: boolean;
	export let dashEditItem: DashWidgetEditType;
	export let editColumn: 'left' | 'right';
	export let hideSelectDash = false;
	export let isAddWizard = false;

	const DEFAULT_DASH_ID = -1;
	const dashIdFromRoute =
		routeParams.type === 'dash' ? $params?.id || DEFAULT_DASH_ID : DEFAULT_DASH_ID;

	let editItem: DashWidgetEditType = {
		id: dashEditItem?.id || '',
		dashboardId: dashEditItem?.dashboardId || dashIdFromRoute,
		col: dashEditItem?.col || 'left',
		position: dashEditItem?.position ?? null,
		widgetTitle: dashEditItem?.widgetTitle || '',
		showWidgetTitle: dashEditItem?.showWidgetTitle ?? true,
		widgetType: dashEditItem?.widgetType || '',
		selectItems: dashEditItem?.selectItems || [],
		cameraConfig: dashEditItem?.cameraConfig,
		widgetsCounter: 0,
	};

	let updatedItem: { type: string; id: any } = {
		type: '',
		id: -1,
	};

	$: if (editColumn) {
		editItem = {
			...editItem,
			col: editColumn,
		};
	}

	$: list =
		$extended_dashboards?.[dashIdFromRoute]?.sort(sortByPosition).map((el) => {
			if (checkIsEventLogTab(el)) {
				el.text = capFirstChar($format(el.text));
			}

			return el;
		}) || [];

	$: updatedDashID = $params?.id || $location?.split('/').filter(Boolean)?.[1];
	$: (updatedDashID, (editItem.dashboardId = updatedDashID));

	const onDashWidgetSaved = () => {
		//Redirect to dash after create new
		const ALL_DASH_WIDGET_ROUTE = `/dash/${editItem.dashboardId}`;
		if (!$location.includes(ALL_DASH_WIDGET_ROUTE)) {
			push(ALL_DASH_WIDGET_ROUTE);
		}
	};
</script>

<DashWizard
	{hideSelectDash}
	bind:showAddEditModal={showModal}
	bind:editItem
	items={list}
	bind:updatedItem
	on:afterAddWidget={onDashWidgetSaved}
	on:close
	{isAddWizard}
/>
